import { render, staticRenderFns } from "./inTransit.vue?vue&type=template&id=ff0bfa10&scoped=true&"
import script from "./inTransit.vue?vue&type=script&lang=js&"
export * from "./inTransit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0bfa10",
  null
  
)

export default component.exports